import {Component, Input} from '@angular/core';
import {TrusteeValue} from '@portal-workspace/grow-shared-library';
import {booleanToYesNo, displaybleDate, notNullUndefined} from '@portal-workspace/grow-shared-library';
import { LiabilitiesSummaryComponent } from './liabilities-summary.component';
import { AssetsSummaryComponent } from './assets-summary.component';
import { MatDividerModule } from '@angular/material/divider';
import { CellComponent } from './cell.component';

import { EllipsisPipe } from '../../pipes/ellipsis.pipe';


@Component({
    selector: 'trustees-summary',
    template: `

@if (trustees) {
  @for (trustee of trustees; track trustee; let index = $index) {
    <div class="row">
      <div class="col-12">
        <div class="application-subsection-title">Trustee {{index + 1}}</div>
      </div>
    </div>
    @if (trustee.type === 'Entity') {
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Type</div>
            <div body>{{trustee.type}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Organisation</div>
            <div body>{{ trustee.organisation.name }}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Organisation type</div>
            <div body>{{trustee.organisationType.name}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ACN</div>
            <div body>{{trustee.acn}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
    }
    @if (trustee.type === 'Individual') {
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Title</div>
            <div body>{{trustee.title?.name}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Type</div>
            <div body>{{trustee.type}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>First name</div>
            <div body><p [innerHTML]="trustee.firstName | ellipsis:10"></p></div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Last name</div>
            <div body><p [innerHTML]="trustee.lastName | ellipsis:10"></p></div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Date of birth</div>
            <div body>{{displayableDate(trustee.dob)}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Residential address</div>
            <div body>{{trustee.residentialAddress?.address}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      @if (trustee.propertyOwner) {
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Property Owner</div>
              <div body>{{booleanToYesNo(trustee.propertyOwner.propertyOwner)}}</div>
            </cell>
          </div>
        </div>
      }
      @if (trustee.propertyOwner && trustee.propertyOwner.propertyOwner) {
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Property address</div>
              <div body>{{trustee.propertyOwner.address?.address}}</div>
            </cell>
          </div>
        </div>
      }
      @if (trustee.propertyOwner && trustee.propertyOwner.propertyOwner) {
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Property value</div>
              <div body>{{trustee.propertyOwner.propertyValue}}</div>
            </cell>
          </div>
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Mortgage value</div>
              <div body>{{trustee.propertyOwner.mortgageValue}}</div>
            </cell>
          </div>
        </div>
      }
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Guarantor</div>
            <div body>{{booleanToYesNo(trustee.guarantor)}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Email address</div>
            <div body>{{trustee.email}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Business landline</div>
            <div body>{{trustee.mobileNumber}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <assets [assets]="trustee.personalAssets"></assets>
      <liabilities-summary [liabilities]="trustee.personalLiabilities"></liabilities-summary>
    }
  }
}

`,
    standalone: true,
    imports: [CellComponent, MatDividerModule, AssetsSummaryComponent, LiabilitiesSummaryComponent, EllipsisPipe]
})
export class TrusteesSummaryComponent {

  booleanToYesNo = booleanToYesNo;
  displayableDate = displaybleDate;
  notNullUndefined = notNullUndefined;

  @Input({required: true}) trustees?: TrusteeValue;

}
